import React from 'react';
import classNames from 'classnames';
import { image } from '../../../../utils/data/baseUrl';
import { icons } from '../../../../constants/rewards';
import { useTranslation } from '../../../../translations';

const Rewards = React.forwardRef(function Reward({ mod, rewards, ...props }, ref) {
  const { t } = useTranslation();
  return (
    <div className={classNames('rewards', { ['rewards_' + mod]: mod, ['rewards_trinity']: rewards.length >= 3 })}>
      {rewards.map(({ type, value }, id) => {
        return (
          (value || value === 'none' || type === 'promo') && (
            <div key={`$item${id}`} className={classNames('rewards__item', { [`rewards__item_${type}`]: type })}>
              <div className='reward__icon'>
                {props?.extraIcons?.[type] ? (
                  <img src={props?.extraIcons?.[type]} alt={type} />
                ) : (
                  <img src={image(icons[type])} alt={type} />
                )}
              </div>
              {value && value !== 'none' && (
                <div className={'reward__value'}>{`${t(value) !== '?' && '+'}${t(value)}`}</div>
              )}
            </div>
          )
        );
      })}
    </div>
  );
});

export default Rewards;
